import { useMemo } from "react";
import { useGameStore } from "@/store/gameStore";
import { formatEvent } from "@/utils/formatEvent";

export default function CenterStage() {
  const state = useGameStore((s) => s.state);

  const text = useMemo(() => {
    if (!state) return "";
    const names = new Map(state.players.map((p) => [p.id, p.hero.name]));
    for (let i = state.log.length - 1; i >= 0; i--) {
      const t = formatEvent(state.log[i], names);
      if (t) return t;
    }
    return "";
  }, [state]);

  return (
    <div className="center-stage">{text || "等待行动..."}</div>
  );
}
